import React from "react";
import { History } from "lucide-react";
import { PendingChoice } from "@/components/vg2/AbbiamoCapitoCard";
import { getStructuredRequest, structuredRequestEnabled } from "@/lib/vg3StructuredRequest";

function VersionNotice({ link, request }) {
  const stale = link.request_version !== request.version;
  if (!stale) {
    return (
      <p className="text-xs text-vg2-muted mb-6" data-testid="request-version-current">
        Risultati calcolati sulla versione {link.request_version} della richiesta (attuale).
      </p>
    );
  }
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 mb-6 flex gap-3" data-testid="request-version-stale">
      <History size={18} className="shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-medium" data-testid="request-version-stale-title">
          Questi risultati si riferiscono alla versione {link.request_version} della richiesta (precedente).
        </p>
        <p className="text-xs text-vg2-muted mt-1" data-testid="request-version-stale-detail">
          La richiesta attuale è la versione {request.version} — «{request.goal_label}». I valori qui sotto non sono ancora aggiornati alla nuova richiesta.
        </p>
      </div>
    </div>
  );
}

export function RequestContinuityBanner({ journeyId, analysisId }) {
  const [data, setData] = React.useState(null);
  const [tick, setTick] = React.useState(0);
  React.useEffect(() => {
    (async () => {
      if (!(await structuredRequestEnabled())) return;
      try { setData(await getStructuredRequest(journeyId)); } catch { setData(null); }
    })();
  }, [journeyId, tick]);
  if (!data || !data.persisted) return null;
  const link = (data.analysis_links || []).find((l) => l.analysis_id === analysisId);
  return (
    <div data-testid="request-continuity-banner">
      {data.pending && (
        <PendingChoice journeyId={journeyId} pending={data.pending} hasResults tid="result-pending"
                       onDone={() => setTick((t) => t + 1)} />
      )}
      {link && <VersionNotice link={link} request={data.request} />}
    </div>
  );
}
